<template lang="pug">
  vm-prompt(@vm-cancel="close" vm-size="medium" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteProductConfirm(form)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.delete_at && read_only" :vm-is-valid="!$v.form.$invalid || !touched" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=4 class="gutters" )
        b-form-group
          vm-input(autofocus :placeholder='$t("supplier_shippment.parcel")' :disabled="read_only" :danger="!$v.form.parcel" :danger-text="'parcel is required'" v-model="form.parcel" :label='$t("supplier_shippment.parcel")')
      vm-col(vm-justify="center", vm-align="center", vm-w=4 class="gutters" )
        b-form-group
          vm-input(autofocus :placeholder='$t("supplier_shippment.guide_number")' :disabled="read_only" :danger="!$v.form.guide_number" :danger-text="'guide_number is required'" v-model="form.guide_number" :label='$t("supplier_shippment.guide_number")')
      vm-col(vm-justify="center", vm-align="center", vm-w=4 class="gutters" )
        b-form-group
          vm-date-picker(:placeholder='$t("supplier_shippment.arrival_date")' :disabled="read_only" type="date" :label='$t("supplier_shippment.arrival_date")' style="width=100%;" v-model="form.arrival_date")
      vm-col(vm-sm=12)
        vm-table(max-height="500px" :data="details")
          template(slot="header")
            .d-flex.justify-content-between
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('supplier_shippment.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                .row
                  slot(v-if="column == 'product'") {{data[indextr]['product']['name']}}
                  slot(v-if="column == 'quantity_ordered'") {{data[indextr]['quantity_ordered']}} / {{data[indextr]['total_quantity']}}
                  .input__wrapper(v-if="column == 'quantity_sent'")
                    vm-input(class="mx-auto" :disabled="(form.reception_status === 'in_progress') || read_only" autofocus v-model="data[indextr]['sending_quantity']" @blur="checkValue(data[indextr])" @keyup="checkValue(data[indextr])" @keypress="checkValue(data[indextr])" style="width:100px;")
                  slot(v-if="column == 'actions' && $auth.check('Admin')")
                    .actions__wrapper
                      vm-button(type="flat" :disabled="form.reception_status === 'in_progress' || read_only" icon="trash-2-outline" color="rgb(242, 19, 93)" @click="deleteSupplierShipmentDetail(data[indextr], tr)")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { required } from 'vuelidate/lib/validators'
const { mapGetters, mapActions } = createNamespacedHelpers('SupplierShippments')

export default {
  name: 'ModalSupplierShipment',
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    read_only: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    form: {
      parcel: {
        required
      },
      guide_number: {
        required
      },
      arrival_date: {
        required
      }
    }
  },
  data: () => ({
    form: {},
    columns: [
      'product',
      'quantity_ordered',
      'quantity_sent',
      'actions'
    ],
    touched: false
  }),
  computed: {
    ...mapGetters(['isModalVisible', 'details']),
    getTitle () {
      return this.read_only ? this.$t('supplier_shippment.preview') : this.$t('supplier_shippment.edit')
    }
  },
  methods: {
    ...mapActions([
      'setModalVisible',
      'loadRecords',
      'updateSupplierShipment',
      'loadPurchaseOrder',
      'deleteShipmentDetail'
    ]),
    checkValue (data) {
      const totalQuantity = data.total_quantity
      const quantitySent = data.quantity_sent
      const quantityOrdered = data.quantity_ordered
      const sendingQuantity = data.sending_quantity

      if (((parseFloat(quantityOrdered) - parseFloat(totalQuantity)) + parseFloat(quantitySent)) < sendingQuantity) data.sending_quantity = ((parseFloat(quantityOrdered) - parseFloat(totalQuantity)) + parseFloat(quantitySent))
      let checked = 0
      this.details.map((detail) => {
        if (detail.sending_quantity && detail.sending_quantity >= 0 && detail.sending_quantity !== null && detail.sending_quantity !== '') checked += parseFloat(detail.sending_quantity)
      })

      checked > 0 ? this.touched = false : this.touched = true
    },
    async saveRecord () {
      this.form.created_by = this.$auth.user().id
      this.updateSupplierShipment({ purchase_order_id: this.$route.params.id, supplier_shipment_id: this.form.id, data: this.form }).then(() => {
        this.loadPurchaseOrder({ id: this.$route.params.id })
        this.loadRecords({ purchase_order_id: this.$route.params.id })
      })
    },
    async deleteSupplierShipmentDetail (detail) {
      let t = this
      this.auxDeleteSale = () => {
        t.deleteShipmentDetail({ supplier_shipment_id: detail.supplier_shipment_id, detail_id: detail.id, data: detail }).then(() => {
          t.loadPurchaseOrder({ id: t.$route.params.id }).then(() => {
            t.loadRecords({ purchase_order_id: t.$route.params.id })
            if (t.details.length === 0) t.setModalVisible(false)
          })
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation2', { model: this.$t('strings.detail'), attribute: this.$t(detail.product.name) }),
        accept: this.auxDeleteSale
      })
    },
    close () {
      if (!this.read_only) {
        this.loadRecords({ purchase_order_id: this.$route.params.id })
      }
      this.setModalVisible(false)
    }
  }
}
</script>

<style lang="scss" scoped>

.input__wrapper,
.actions__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.gutters {
  padding: 10px;
}
</style>
